import React, { ReactNode } from "react";
import classnames from "classnames";

import "./EmptyTBody.scss";

interface EmptyTBodyProps {
  className?: string;
  children: ReactNode;
}

export const EmptyTBody = ({ className, children }: EmptyTBodyProps) => {
  return (
    <div role="rowgroup" className={classnames("empty-tbody", className)}>
      <div role="row">
        <div role="cell" className="empty-tbody__cell">
          {children}
        </div>
      </div>
    </div>
  );
};
